import React from "react"
import Modal from "aldoo-ra/Modal"
import CMSRender from "aldoo-ra/CMS/cms-render"
import Button from "aldoo-ra/Button"
import Typography from "aldoo-ra/Typography"
import { ChevronLeftIcon } from "@heroicons/react/20/solid"

export default function ProviderAwaitDialog({ controller }) {
  const { provider, closeDialog, backToSignIn, DialogType, isDialogOpen } =
    controller

  return (
    <Modal
      isOpen={isDialogOpen(DialogType.PROVIDER)}
      onClose={closeDialog}
      variant="mobilingo_medium"
      className="max-w-[534px]"
    >
      <CMSRender
        contentType="SigninProviderAwaitDialog"
        renderItem={(dialog) => (
          <div className="relative bg-paper w-full max-w-[408px] text-center pb-2 mx-auto">
            {/* Icon */}
            <div className="flex justify-center mb-8 bg-gray_200 rounded-full p-1 w-[80px] mx-auto">
              <img
                src={provider?.logo}
                alt="Sign in with provider"
                className="w-16 h-16"
              />
            </div>

            {/* Title */}
            <Typography
              variant="body1"
              className="mb-[30px]"
            >
              {dialog.title.replace(
                "{{provider}}",
                provider?.name || "Provider"
              )}
            </Typography>

            {/* Line Divider */}
            <div className="w-full border border-bordered mb-[44px] mx-auto" />

            {/* Description */}
            <Typography variant="txt1_dim">
              {dialog.description}
            </Typography>

            {/* Back to Sign In Button */}
            <div className="w-full flex items-center justify-center mt-[24px] mx-auto">
              <Button
                variant="text_btn_ghost"
                onClick={backToSignIn}
                className="flex items-center gap-2"
              >
                <ChevronLeftIcon className="w-6 h-6" />
                <span>{dialog.back_to_login_text}</span>
              </Button>
            </div>
          </div>
        )}
      />
    </Modal>
  )
}